module.exports = __webpack_public_path__ + "img/42.26aa61a4.webp";